









import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting, Theme} from '@/services/settings/Settings.types';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {},
})
export default class ThemeSelector extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ISettingsService'))
  private settingsService!: ISettingsService;

  private selectedTheme: number = this.settingsService.get(Setting.Theme) === Theme.Light ? 0 : 1;

  private setLightTheme() {
    this.$vuetify.theme.dark = false;
    this.settingsService.set(Setting.Theme, Theme.Light);
  }

  private setDarkTheme() {
    this.$vuetify.theme.dark = true;
    this.settingsService.set(Setting.Theme, Theme.Dark);
  }
}
